import { Window_FillRateFallback } from './Window_FillRateFallback';
import CoinShopSpinBtn from '../IAP/G.CoinshopSpinBtn';
import { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';
import OOMBuyMovesButton from '../IAP/G.OOMBuyMovesBtn';
import LevelEconomyTracker from '../GameTracking/LevelEconomyTracker';
import { Window } from '../../00_IMMEDIATE/Window';
import CoinShopWheel from '../IAP/G.CoinShopWheel';
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-use-before-define */

export class Window_OutOfMovesIAP extends Window {
  /**
   * Shows when the player runs out of moves in a level.
   * @param {Object} parent
   * @param {Object} popUpConfig
   * @memberof Window_OutOfMovesIAP
   */
  constructor(parent, popUpConfig) {
    super(parent);

    // the view we're currently showing.  can be fail view or wheel view
    this.currentView = null;

    this.popUpConfig = popUpConfig || {};

    console.log('Lvl finished', G.lvl.lvlIndex + 1, G.lvl.points);
    sdkHandler.trigger('levelFinish', {
      level: G.lvl.lvlIndex + 1,
      score: G.lvl.points,
      state: 'lose',
    }, this);

    if (popUpConfig.position) {
      this.position.copyFrom(popUpConfig.position);
    }

    // whether the player has earned extra moves when we close the window
    this.outOfMovesResolved = false;

    // setting up layout
    // background
    this.addBackground('popup_background_2');

    this.failView = this.addFailView();

    // coin bar to show the player how many coins they have
    this.coinBar = new G.CoinBar(0, -420);
    // cant add coins while wheel is spinning or we're already in the catalog
    this.coinBar.plusBtn.addTerm(() => !this.wheelGroup.isDuringSpin() /* && this.currentView !== this.catalog; */); // it looks like we no longer use the catalog view
    this.coinBar.onPlusBtnClicked.add(() => {
      this.goToShopCoin(false);
    });
    this.coinBar.plusBtn.visible = G.IAP;
    this.add(this.coinBar);

    const featureConfig = { failFlow: true, coinTargetObject: this.coinBar };
    this.wheelGroup = new CoinShopWheel(featureConfig);
    // we show the fail view at first, so hide the wheel
    this.wheelGroup.alpha = 0;
    // if the player gets the booster, then they have more moves and we can resolve this window
    this.wheelGroup.onBoosterWon.add((prize) => { this.resolveOutOfMoves(false, prize); });
    // if not, then we just go back to the fail view
    this.wheelGroup.onCoinsWon.add(() => {
      this.showView(this.failView);
    });
    this.add(this.wheelGroup);

    this.views = [this.failView, this.wheelGroup];
    this.showView(this.failView);

    // setting up buttons
    this.closeBtn = this.addCloseBtn();
  }

  /**
   * Add the default view that is first shown when the window pops up.
   *
   * @returns The view that was added.
   * @memberof Window_OutOfMovesIAP
   */
  addFailView() {
    const group = game.make.group();

    // banner
    if (G.OMTsettings.global.jungleMatch) {
      group.blue_banner = G.makeImage(0, -295, 'purple_banner', 0.5, this);
      group.add(group.blue_banner);
    }

    const yOffset = G.OMTsettings.global.jungleMatch ? -297 : -270;

    // setting up layout
    group.titleTxt = new G.Text(0, yOffset, OMT.language.getText('Out of moves!'), G.OMTsettings.global.window.mediumTitle.textStyle, 0.5, 350);
    group.add(group.titleTxt);

    group.info = new G.OutOfMovesInfoPanel(0, -100);
    group.add(group.info);

    const onSuccess = () => {
      LevelEconomyTracker.getInstance().onWheelSpin();
      this.showView(this.wheelGroup);
    };

    // setting up buttons
    const spinBtn = new CoinShopSpinBtn(0, 240, {
      button: {
        tint: BUTTONCOLOURS.green,
        dimensions: {
          width: 445,
          height: 100,
        },
        extraDetail: false,
      },
      text: {
        string: '',
        textStyle: {
          style: 'font-white',
          fontSize: 50,
        },
      },
      options: {
        cacheButton: false,
      },
    });
    group.spinBtn = spinBtn;
    spinBtn.signals.onClick.add(() => {
      if (G.saveState.isFreeMoneySpinAvailable() && G.featureUnlock.freeFailFlowWheelSpin) {
        onSuccess.call(this);
      } else if (game.incentivised()) {
        sdkHandler.trigger('rewardedAd',{     
          callback: (success) => { 
              if (success) {onSuccess();} 
              else {/* 'no more videos screen */ 
                          new Window_FillRateFallback(undefined, {
                placement: G.BuildEnvironment.adPlacements.spinTheLevelLostWheel,
                callback: onSuccess.bind(this),
                context: this,
              });
            }
          } 
      },this);
        // OMT.ads.showAd(
        //   G.BuildEnvironment.adPlacements.spinTheLevelLostWheel,
        //   onSuccess.bind(this),
        //   // on ad fail
        //   () => {
        //     if (!G.IAP) { // no IAPS dont use ad fallbacks
        //       // eslint-disable-next-line no-new
        //       new Window_FillRateFallback(undefined, {
        //         placement: G.BuildEnvironment.adPlacements.spinTheLevelLostWheel,
        //         callback: onSuccess.bind(this),
        //         context: this,
        //       });
        //     } else { // open ad fallback
        //       OMT.ads.showAdFallback(onSuccess.bind(this));
        //     }
        //   },
        // );
      }

      if (DDNA.tracking.enabled) {
      DDNA.tracking.getDataCapture().addToPlayerCharacterizationSessionParam('lossAversionActionsThisSession', 1);
      }
      // eslint-disable-next-line no-useless-return
      return;
    });
    group.add(group.spinBtn);

    group.add(
      this.addBuyMovesBtn(0, 130),
    );

    this.add(group);
    return group;
  }

  /**
   * Handles when the outOfMoves window is closed.
   *
   * @memberof Window_OutOfMovesIAP
   */
  closeWindow(doClosingProcess = true) {
    if (doClosingProcess) {
      if (this.popUpConfig.closeCallback) {
        this.popUpConfig.closeCallback();
      }

      if (!this.outOfMovesResolved) {
        if (G.IAP
          && G.lvl.lvlIndex === G.saveState.data.failedCurrentLevel.level
          && G.lvl.lvlIndex >= 9
          && G.saveState.data.failedCurrentLevel.fails >= 2
          && G.saveState.getUserCooldownRemaining('popupOffer', '') === 0
          && OMT.payments.getCatalogSync().length > 0
        ) {
          if (Math.random() <= 0.5 + (G.saveState.data.failedCurrentLevel.fails - 2) * 0.1) {
            G.saveState.setUserCooldown('popupOffer', '', 1000 * 60 * 60 * 24);
            G.saveState.save();
            G.sb('pushWindow').dispatch('popupOffer');
          }
        }
        G.sb('pushWindow').dispatch('levelFailed');
      }
    }
    super.closeWindow();
  }

  /**
   * Adds and sets up the button to close the window
   *
   * @returns The close button
   * @memberof Window_OutOfMovesIAP
   */
  addCloseBtn() {
    this.closeButton = new G.Button(235, -257, 'btn_x', () => {
      if (this.currentView === this.failView) {
        if (this.popUpConfig.preCloseCallback && !this.popUpConfig.preCloseCallback()) {
          // callback returns false - prevent closing
          return;
        }
        this.closeWindow();
      } else {
        this.showView(this.failView);
      }
    });
    this.registerButtons(this.closeButton);
    // can't close the window if the wheel is spinning
    this.closeButton.addTerm(() => !this.wheelGroup.isDuringSpin());

    return this.closeButton;
  }


  /**
   * Handles the case where the player earns more moves
   * @param {boolean} force5moves (optional) default false
   * @memberof Window_OutOfMovesIAP
   */
  resolveOutOfMoves(force5moves = false, prize) {
    console.log(`resolved! prize: ${prize}`)
    this.outOfMovesResolved = true;
    if (prize === 'booster#5Instant' || prize === 'booster#6Instant' || !prize) {
      // essentially, we should always give three moves unless the buy extra moves button was clicked (it uses force5Moves)
      if ((!G.IAP && !G.featureUnlock.multipleExtraMovesFailFlow) || force5moves) {
        // adding booster, they will be used by startbooster action
        G.saveState.changeBoosterAmount(5, 1, true);
        this.state.startBoosters.player = [false, false, false, false, false, true, false];
      } else {
        G.saveState.changeBoosterAmount(6, 1, true);
        this.state.startBoosters.player = [false, false, false, false, false, false, true];
      }
    } else if (prize === 'booster#10Instant') { // prize was one move
      G.saveState.changeBoosterAmount(10, 1, true);
      this.state.startBoosters.player = [false, false, false, false, false, false, false, false, false, false, true];
    } else if (prize === 'booster#11Instant') { // prize was two moves
      G.saveState.changeBoosterAmount(11, 1, true);
      this.state.startBoosters.player = [false, false, false, false, false, false, false, false, false, false, false, true];
    }

    this.state.board.actionManager.newAction('startBoosterInit', 'outOfMovesIAP');
    if (this.popUpConfig.onResolveCallback) {
      this.popUpConfig.onResolveCallback()
    }
    this.closeWindow();
  }

  /**
   * Sends the player to the shop, if they want to buy more coins.
   *
   * @param {boolean} forcedOpening Whether the shop opening was forced or was chosen by the player
   * @memberof Window_OutOfMovesIAP
   */
  goToShopCoin(forcedOpening) {
    G.sb('pushWindow').dispatch(['coinShop', {
      forced: forcedOpening,
    }]);
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.OpenShop);
    OMT.platformTracking.logEvent(OMT.platformTracking.Events.OpenShopMoves);
    G.sb('pushWindow').dispatch(['outOfMovesIAP', this.popUpConfig]);
    this.closeWindow(false);
  }

  /**
   * Add the button to buy moves
   *
   * @param {number} x The x position of the button
   * @param {number} y The y position of the button
   * @returns The button
   * @memberof Window_OutOfMovesIAP
   */
  addBuyMovesBtn(x, y) {
    const boosterType = G.gift.GiftContentType.StartBoosterDefaultMovesInstant;
    let boosterRewardType = boosterType;
    if (boosterType.toLowerCase().indexOf('instant') > -1) { // For rewards DDNA purposes, I need the non-instant version
      boosterRewardType = boosterType.substr(0, G.gift.GiftContentType.StartBoosterDefaultMoves.length);
    }
    const { failFlowConfig } = G.json.settings;
    const currentPurchaseIndex = G.lvl.numOfExtraMovesBought;
    let price = G.lvl.getPriceOfExtraMoves();
    // use old way multiplier calculate the price
    if (!failFlowConfig) {
      price = Math.round(price * 1.1);
    }
    let additionalBooster = null;

    if (failFlowConfig && currentPurchaseIndex >= failFlowConfig.additionalBooster.unlockAtPurchaseIndex) {
      additionalBooster = G.gift.processGift(G.Utils.clone(failFlowConfig.additionalBooster.gift));
    }

    const processClick = () => {
      // if we somehow click the buy button while the wheel is spinning, return
      if (this.wheelGroup.isDuringSpin()) { return; }
      console.log('wheel aint spinning')
      if (G.saveState.getCoins() >= price) {
        console.log('can afford it');
        // here, this is scoped to the btn
        this.lockInput();

        // eslint-disable-next-line no-undef
        const rewards = [[boosterRewardType, 1]]; // list for merging to 1 tracking event for ddna
        if (additionalBooster) rewards.push(additionalBooster);

        G.saveState.changeCoins(-price);

        G.sfx.cash_register.play();
        // eslint-disable-next-line no-undef
        this.resolveOutOfMoves(true);
        G.lvl.markExtraMovesPurchase(price);

        if (DDNA.tracking.enabled) {
        const dataCapture = DDNA.tracking.getDataCapture();
        dataCapture.addToPlayerCharacterizationSessionParam('extraMovesRescueBoughtThisSession', 1);
        dataCapture.addToPlayerCharacterizationSessionParam('lossAversionActionsThisSession', 1);

        DDNA.transactionHelper.trackRewards(rewards, rewards[0], {
          transactionType: 'COIN_PURCHASE',
          tActionType: 'BOOSTER_USE',
          tGameArea: 'FAIL_FLOW',
          tCoinsUsed: price,
          tFailFlowExtraMoves: 1,
          tLevelExtraMoves: true, // *** COOK-OMT Duplicate ***
        });
      }

        OMT.transactionTracking.logInventoryTransactionBegin();
        OMT.transactionTracking.addInventoryChange('coins', 0, -price);

        const boosterNum = parseInt(boosterType.match(/\d+/)[0]);
        if (boosterNum && boosterNum !== 5 && boosterNum !== 6) { // don't track +3 and +5 moves
          OMT.transactionTracking.addInventoryChange('boostersReceived', boosterNum, 1);
          OMT.transactionTracking.addInventoryChange('boostersUsed', boosterNum, 1);
        }
        if (additionalBooster) G.gift.applyGift(additionalBooster, false, 'Gameplay', 'FailFlowPurchase');

        OMT.transactionTracking.logInventoryTransactionEnd();
      } else if (G.IAP) {
        // using self here because `this` is scoped to the buy btn
        this.goToShopCoin(true);
      }
    };

    this.buyButton = new OOMBuyMovesButton(x, y, price, additionalBooster, boosterType);
    this.buyButton.signals.onClick.add(processClick.bind(this));
    this.registerButtons(this.buyButton);

    if (!G.IAP && !game.incentivised() && price > G.saveState.data.coins) {
      this.buyButton.visible = false;
    }

    return this.buyButton;
  }

  /**
   * Show a given view, and hide all other views
   *
   * @param {boolean} toShow The view to show
   * @returns If the view can't be shown, either because it doesnt exist or because its currently being shown
   * @memberof Window_OutOfMovesIAP
   */
  showView(toShow) {
    // if toShow doesnt exist or we're already showing it, return
    if (!toShow) return;
    if (this.currentView === toShow) return;

    this.currentView = toShow;

    // disable input of not-shown views and hide them, and enable input on/show the current view.
    this.views.forEach((view) => {
      if (view === toShow) {
        view.ignoreChildInput = false;
        view.y = 0;
        game.add.tween(view)
          .to({ alpha: 1 }, 300, Phaser.Easing.Sinusoidal.In, true);
      } else {
        view.ignoreChildInput = true;
        if (view.alpha !== 0) {
          game.add.tween(view)
            .to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.In, true)
            .onComplete.add(() => {
              view.y = -9999;
            });
        } else {
          view.y = -9999;
        }
      }
    });
  }
}

// create global references
if (!window.Windows) window.Windows = {};
Windows.outOfMovesIAP = Window_OutOfMovesIAP;
